module.exports = __webpack_public_path__ + "img/works_ssFire_btm_m.28f2ae3e.jpg";